import config from 'app.config';
import { SPECIALTY } from 'common/constants';
import { OfferedAppointmentType, Provider } from 'types/Provider';

export const getOfferedAppointmentType = (provider: Provider): OfferedAppointmentType | undefined => {
  const offeredAppointmentTypes = provider?.offeredAppointmentTypes || [];

  const defaultTypes = offeredAppointmentTypes.filter(
    (offeredAppointmentType) =>
      offeredAppointmentType.appointmentType?.name?.toLowerCase() === 'initial visit'
      && offeredAppointmentType.appointmentType?.specialty?.id === SPECIALTY.dentist,
  );

  // If there are multiple defaultTypes, return the one with the shortest duration
  return defaultTypes.sort((a, b) => a.appointmentType?.duration - b.appointmentType?.duration).at(0);
};

export const getPatientAppUrl = (appointmentId: string | number) =>
  `${config.PATIENT_APP_URL}/#/appointment/${appointmentId}/?source=Recommendations&walkthrough=true`;
